import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index.vue'
import Index618 from './views/index618.vue'
import Crm from './views/CRM.vue'
import Outbound from './views/Outbound.vue'
import BusAgent from './views/BusAgent.vue'
import News from './views/news/index.vue'
import About from './views/About.vue'
import NewsDetails from './views/news/newsDetail.vue'
import Product from './views/product/index.vue'
import Ipswitch from './views/product/ipswitch.vue'
import FormMarket from './views/product/formMarket.vue'
import Show from './views/product/show.vue'
import HuiTalk from './views/product/huiTalk.vue'
import HuiVisitors from './views/product/huiVisitors.vue'
import Card from './views/product/card.vue'
import Poster from './views/product/poster.vue'
import Hot from './views/product/hot.vue'
import LetterE from './views/product/letterE.vue'
import WxMarket from './views/product/wxMarket.vue'
import Robot from './views/product/robot.vue'
import Customer from './views/product/customer.vue'
import Sale from './views/product/sale.vue'
import Zqn from './views/zqn.vue'

import TelemarketingLine from './views/TelemarketingLine.vue'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/softDown',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Index',
      component: Index,
    },
    {
      path: '/index618',
      name: 'index618',
      component: Index618,
    },
    {
      path: '/crm',
      name: 'CRM',
      component: Crm,
    },
    {
      path: '/outbound',
      name: 'Outbound',
      component: Outbound,
    },
    {
      path: '/busAgent',
      name: 'BusAgent',
      component: BusAgent,
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      meta: {
        hiddenFooter: true
      }
    },
    {
      path: '/zqn',
      name: 'zqn',
      component: Zqn
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/newsdetails',
      name: 'newsDetail',
      component: NewsDetails,
    },
    {
      path: '/telemarketingLine',
      name: 'telemarketingLine',
      component: TelemarketingLine,
    },
    {
      path: '/product',
      name: 'prodcut',
      component: Product,
      children: [
        {
          path: 'ipswitch',
          name: 'ipswitch',
          component: Ipswitch,
        },
        {
          path: 'formMarket',
          name: 'formMarket',
          component: FormMarket,
        },
        {
          path: 'show',
          name: 'show',
          component: Show,
        },
        {
          path: 'huiTalk',
          name: 'huiTalk',
          component: HuiTalk,
        },
        {
          path: 'huiVisitors',
          name: 'huiVisitors',
          component: HuiVisitors,
        },
        {
          path: 'card',
          name: 'card',
          component: Card,
        },
        {
          path: 'poster',
          name: 'poster',
          component: Poster,
        },
        {
          path: 'hot',
          name: 'hot',
          component: Hot,
        },
        {
          path: 'letterE',
          name: 'letterE',
          component: LetterE,
        },
        {
          path: 'wxMarket',
          name: 'wxMarket',
          component: WxMarket,
        },
        {
          path: 'robot',
          name: 'xiaofeng',
          component: Robot,
        },
        {
          path: 'customer',
          name: 'customer',
          component: Customer,
        },
        {
          path: 'sale',
          name: 'sale',
          component: Sale,
        },
      ]
    }
  ]
})

router.afterEach(() => {
  window.scrollTo(0, 0);
});
export default router